import { Injectable, Injector } from "@angular/core";
import { CoreLogService } from "./log.service";
import { CoreCOMService } from "./com.service";
import { ISafeFileSystem } from "./safeFileSystem.service";
import { YourAppServer } from "./YourAppServer.service";
import { Observable, ReplaySubject } from "rxjs";
import { InHouseOrderService } from "./inHouseOrder.service";
import { INHOUSEORDER_SERVICE_INJECTION_TOKEN } from "../../injectionToken";

/** Helper for inject around the circular problem  */
@Injectable()
export class CircularInjectionHelper {
  private _onInit = new ReplaySubject<void>();
  private _coreCOMService: CoreCOMService;
  private _safeFilesystem: ISafeFileSystem;
  private _yourAppServer: YourAppServer;
  private _injector: Injector;
  private _inHouseOrderService: InHouseOrderService;

  constructor(public readonly coreLogService: CoreLogService) {
    this._coreCOMService = null;
    this._safeFilesystem = null;
    this._yourAppServer = null;
    this._inHouseOrderService = null;
  }

  public Initilize(coreCOMService: CoreCOMService, safeFilesystem: ISafeFileSystem, yourAppServer: YourAppServer, injector: Injector): void {
    this._coreCOMService = coreCOMService;
    this._safeFilesystem = safeFilesystem;
    this._yourAppServer = yourAppServer;
    this._injector = injector;
    this._onInit.next(); // Notify over the init complete (next is used, not complete for the subscriber)
  }

  /** Notifyer of initialization is done */
  public get ObserveOnInit(): Observable<void> {
    return this._onInit;
  }

  public get coreCOMService(): CoreCOMService {
    return this._coreCOMService;
  }

  public get safeFilesystem(): ISafeFileSystem {
    return this._safeFilesystem;
  }

  public get yourAppServer(): YourAppServer {
    return this._yourAppServer;
  }

  // todo muss zu einem Interface
  public get inHouseOrderService(): InHouseOrderService {
    if (!this._inHouseOrderService) {
      this._inHouseOrderService = this._injector.get(INHOUSEORDER_SERVICE_INJECTION_TOKEN); // TODO _injector wenn möglich entfernen
    }
    return this._inHouseOrderService;
  }
}
